import { inject, Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { HttpHandlerEntity } from '../models/http-handler';
import { HttpParams } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { DownloaderService } from 'src/app/shared/download/downloader.service';
import { DataFieldGroup, DataFieldValue } from 'src/app/shared/datafields/models';
import { InitConfiguration } from 'src/app/distribution/models/init-configuration';

@Injectable({
    providedIn: 'root'
})
export class HttpHandlerService {
    private httpService = inject(JsonHttpService);
    private downloaderService = inject(DownloaderService);

    getHttpHandlers(): Promise<HttpHandlerEntity[]> {
        return this.httpService.get('/api/transport/http-handlers/get-http-handlers').toPromise();
    }

    saveHttpHandler(entity: HttpHandlerEntity, datafieldValues: DataFieldValue[]): Promise<HttpHandlerEntity> {
        const saveObject = {
            HttpHandler: entity,
            Values: datafieldValues
        };
        return this.httpService.post('/api/transport/http-handlers/save-http-handler', saveObject, null, false).toPromise();
    }

    saveHttpHandlerInitConfig(httpHandlerId: number, initConfig: InitConfiguration): Promise<InitConfiguration> {
        const options = { params: new HttpParams().set('httpHandlerId', httpHandlerId.toString()) };
        return this.httpService.post('/api/transport/http-handlers/save-http-handler-init-config', initConfig, options).toPromise();
    }

    deleteHttpHandlerInitConfig(httpHandlerId: number) {
        const options = { params: new HttpParams().set('httpHandlerId', httpHandlerId.toString()) };
        return this.httpService.post('/api/transport/http-handlers/delete-http-handler-init-config', null, options).toPromise();
    }

    getHttpHandlerInitConfig(httpHandlerId: number): Promise<InitConfiguration> {
        const options = { params: new HttpParams().set('httpHandlerId', httpHandlerId.toString()) };
        return this.httpService.get('/api/transport/http-handlers/get-http-handler-init-config', options).toPromise();
    }

    deleteHttpHandler(id: number) {
        const options = { params: new HttpParams().set('httpHandlerId', id.toString()) };
        return this.httpService.post('/api/transport/http-handlers/delete-http-handler', null, options, false).toPromise();
    }

    getHttpHandlerDataFieldGroups(artifactId: string, httpHandlerId?: number): Promise<DataFieldGroup[]> {
        const options = { params: new HttpParams().set('artifactId', artifactId) };
        if (httpHandlerId) {
            options.params = options.params.set('httpHandlerId', httpHandlerId);
        }
        return this.httpService.get('/api/transport/http-handlers/get-http-handler-datafields', options).toPromise();
    }

    getBaseApiUrl(): Promise<string> {
        return this.httpService.get('/api/transport/http-handlers/get-base-api-url').toPromise();
    }

    async exportHttpHandlers(httpHandlerIds: number[]): Promise<void> {
            const filename = `HttpHandlerExport_${formatDate(new Date(), 'yyyyMMdd_HHmmss', 'en')}`;
            const body = { filename, ids: httpHandlerIds };
            await this.httpService.post('/api/transport/http-handlers/export-http-handlers', body).pipe(
                switchMap(token => this.downloaderService.downloadFile(token))
            ).toPromise();
        }
}
